import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Team } from '../../_shared/models/team.model';
import { CreateTeamComponent } from '../create-team/create-team.component';

@Component({
  standalone: false,
    selector: 'app-create-team-fab',
    templateUrl: './create-team-fab.component.html',
    styleUrls: ['./create-team-fab.component.scss'],
})
export class CreateTeamFabComponent {
    @Input() leagueId: string;
    @Input() closeAllModalsOnSuccess = true;
    @Output() team: EventEmitter<Team> = new EventEmitter();

    constructor(
        private modalController: ModalController
    ) { }

    public async createTeam(leagueId?: string) {
        const modal = await this.modalController.create({
            component: CreateTeamComponent,
            componentProps: {
                leagueId,
                closeAllModalsOnSuccess: this.closeAllModalsOnSuccess
            },
            id: 'create-team-modal',
            presentingElement: await this.modalController.getTop()
        });

        await modal.present();

        const { data } = await modal.onDidDismiss();

        if (data) {
            this.team.emit(data);
        }
    }

}
